import { APIDecoratorWithBaseURI } from './api'

// Same service and base path the dashboard already uses for eventInfo/getOs*.
const BASE = 'producer/analytics'

export interface EventAccess {
  eventId: string
  hasAccess: boolean
}

/**
 * Asks the API whether the current user may open `eventId`.
 *
 * The dashboard used to answer this locally from the `producerEvents` JWT claim,
 * which is capped at 300 ids — so a producer with more links than that was told
 * their own newest events did not exist. Ownership is now resolved server-side per
 * request, which also means a revoked link takes effect immediately rather than
 * whenever the token happens to expire.
 *
 * Throws on transport failure so callers can tell a denial apart from an outage;
 * a genuine denial comes back as a 200 with `hasAccess: false`.
 */
export const checkEventAccess = async (eventId: string): Promise<boolean> => {
  const response = await APIDecoratorWithBaseURI().get(
    `${BASE}/checkEventAccess?eventId=${encodeURIComponent(eventId)}`
  )

  return response?.data?.body?.hasAccess === true
}
